import { FC } from "react"
import AlertSoundRadioButton from "../AlertSoundRadioButton"
import { noSoundFile, SoundFile, soundFiles } from "../files"
import { AudioPlayer } from "@/components/AudioPlayer"
import { Icon, IconColor } from "@/components/shared/Icon"

interface AlertSoundOptionsListProps {
   isEditing: boolean
   soundFile: SoundFile
   formSoundFile: SoundFile
   setFormSoundFile: (soundFile: SoundFile) => void
}

const AlertSoundOptionsList: FC<AlertSoundOptionsListProps> = ({
   isEditing,
   soundFile,
   formSoundFile,
   setFormSoundFile,
}) => {
   return (
      <>
         {isEditing ? (
            <>
               <tr key="sound-file-none">
                  <td>
                     <AlertSoundRadioButton
                        value="none"
                        label="No sound"
                        id="sound-file-none"
                        onChange={() => {
                           setFormSoundFile(noSoundFile)
                        }}
                        checked={formSoundFile.value === "none"}
                     />
                  </td>
               </tr>
               {soundFiles.map((soundFile, index) => {
                  return (
                     <tr key={`sound-file-${index}`}>
                        <td>
                           <AlertSoundRadioButton
                              value={soundFile.value}
                              label={soundFile.label}
                              id={`sound-file-${index}`}
                              onChange={() => {
                                 setFormSoundFile(soundFile)
                              }}
                              checked={formSoundFile.value === soundFile.value}
                           />
                           <AudioPlayer
                              src={soundFile.value}
                              type={soundFile.type}
                              autoPlay={false}
                              stopOthers
                           />
                        </td>
                     </tr>
                  )
               })}
            </>
         ) : (
            <tr key="sound-file-none">
               <td>
                  {soundFile.value === "none" ? (
                     <>
                        <span>No sound</span>
                        <Icon
                           size="16"
                           color={IconColor.HONOLULU_BLUE}
                           name="mute"
                        />
                     </>
                  ) : (
                     <>
                        <span>{soundFile.label}</span>
                        <AudioPlayer
                           src={soundFile.value}
                           type={soundFile.type}
                           autoPlay={false}
                           stopOthers
                        />
                     </>
                  )}
               </td>
            </tr>
         )}
      </>
   )
}

export default AlertSoundOptionsList
